import { Box } from '@mui/material';

import { SportsMatchCard } from '@/components';

type MatchData = {
  id: string;
  team1: {
    id: string;
    name: string;
    logo?: React.ReactNode;
    percentage: number;
  };
  team2: {
    id: string;
    name: string;
    logo?: React.ReactNode;
    percentage: number;
  };
  volume: string;
  league: string;
  dateTime: string;
  selectedOutcome?: 'team1' | 'draw' | 'team2';
};

const HamburgerLogo = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      borderRadius: '4px',
      bgcolor: '#e8b046',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: 12,
        height: 12,
        border: '2px solid #ffffff',
        borderRadius: '2px',
        transform: 'rotate(45deg)',
      }}
    />
  </Box>
);

const EintrachtLogo = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      borderRadius: '50%',
      bgcolor: '#c24632',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: 16,
        height: 12,
        border: '2px solid #ffffff',
        borderTop: 'none',
        borderRadius: '0 0 8px 8px',
      }}
    />
  </Box>
);

const RBLeipzigLogo = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      borderRadius: '50%',
      bgcolor: '#c24632',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: 14,
        height: 14,
        border: '2px solid #ffffff',
        borderRadius: '2px',
      }}
    />
  </Box>
);

const BayerLogo = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      borderRadius: '4px',
      bgcolor: '#c24632',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    }}
  >
    <Box
      sx={{
        width: 16,
        height: 16,
        border: '2px solid #ffffff',
        borderRadius: '2px',
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        top: 2,
        left: 2,
        width: 6,
        height: 6,
        bgcolor: '#000000',
        borderRadius: '1px',
      }}
    />
  </Box>
);

const MOCK_MATCHES: MatchData[] = [
  {
    id: 'hamburger-eintracht',
    team1: {
      id: 'hamburger',
      name: 'Hamburger SV',
      logo: <HamburgerLogo />,
      percentage: 36,
    },
    team2: {
      id: 'eintracht',
      name: 'Eintracht Frankfurt',
      logo: <EintrachtLogo />,
      percentage: 37,
    },
    volume: '$279k',
    league: 'BUNDESLIGA',
    dateTime: 'Tomorrow 8:00 PM',
    selectedOutcome: 'team2',
  },
  {
    id: 'rb-leipzig-bayer',
    team1: {
      id: 'rb-leipzig',
      name: 'RB Leipzig',
      logo: <RBLeipzigLogo />,
      percentage: 46,
    },
    team2: {
      id: 'bayer',
      name: 'Bayer 04',
      logo: <BayerLogo />,
      percentage: 29,
    },
    volume: '$242k',
    league: 'BUNDESLIGA',
    dateTime: 'Tomorrow 11:00 PM',
    selectedOutcome: 'team1',
  },
];

type SportsMatchCardItemProps = {
  match: MatchData;
  onTradeClick?: (matchId: string, outcome: 'team1' | 'draw' | 'team2') => void;
};

const SportsMatchCardItem = ({ match, onTradeClick }: SportsMatchCardItemProps) => {
  return (
    <SportsMatchCard
      id={match.id}
      team1={match.team1}
      team2={match.team2}
      volume={match.volume}
      league={match.league}
      dateTime={match.dateTime}
      selectedOutcome={match.selectedOutcome}
      onTradeClick={onTradeClick}
    />
  );
};

type SportsMatchCardListProps = {
  onTradeClick?: (matchId: string, outcome: 'team1' | 'draw' | 'team2') => void;
};

export const SportsMatchCardList = ({ onTradeClick }: SportsMatchCardListProps) => {
  return (
    <>
      {MOCK_MATCHES.map((match) => (
        <SportsMatchCardItem key={match.id} match={match} onTradeClick={onTradeClick} />
      ))}
    </>
  );
};

export default SportsMatchCardList;
